module.exports = __webpack_public_path__ + "8714930bad0e6cdb1eea970922f9eb15.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/3931.jpg
// module id = 685
// module chunks = 0